module.exports = __webpack_public_path__ + "static/media/dwnewsmall.643f795b.png";